<template>
  <div>
    <h6 class="feta opacity-48 mb-2">
      Поделиться
    </h6>
    <div class="flex gap-4">
      <ShareNetwork
        v-for="(V, K, idx) in networksFix"
        :key="idx"
        :network="K"
        :url="url"
        :title="title"
        :description="description"
        :quote="quote"
        :hashtags="hashtags"
        :twitter-user="twitterUser"
      >
        <!-- <img :src="require(`@/static/img/SocialSharing_icon/${network}.svg`)" alt=""> -->
        <!-- <img :src="It.icon" alt=""> -->
        <img
          :src="`https://storage.rosatom.city/platform-test/vue-culture/icons/${V}_32.svg`"
          alt=""
          :title="`Поделиться ${K}`"
        >
        <!-- <span>{{ It.icon }}</span> -->
      </ShareNetwork>
      <!-- <pre>{{NETWORKS}}</pre> -->
    </div>
  </div>
</template>

<script>
export default {
  // https://nicolasbeauvais.github.io/vue-social-sharing/?path=/story/vuesocialsharing--dynamic-data
  props: {
    url: {
      type: String,
      default: location.href
    },
    title: {
      type: String,
      default: 'title'
    },
    description: {
      type: String,
      default: 'description'
    },
    quote: {
      type: String,
      default: 'quote'
    },
    hashtags: {
      type: String,
      default: 'hashtags'
    },
    twitterUser: {
      type: String,
      default: 'twitterUser'
    }
  },

  data() {
    return {
      // networks: ['vk', 'facebook', 'odnoklassniki'],
      // icon: new URL(`/static/img/SocialSharing_icon/${It}.svg`, import.meta.url)
      networksFix: {
        vk: 'Vkontakte',
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        viber: 'Viber'
      }
    };
  },
  computed: {
    // NETWORKS() {
    //   return Object.entries(this.networksFix).map(pair => ({
    //       name: pair[0],
    //       icon: new URL(`https://storage.rosatom.city/platform-test/vue-culture/icons/${pair[1]}_32.svg`, import.meta.url)
    //   }))
    // }
  }
};
</script>

<style></style>
